import{captureEvent as e,captureException as o,captureMessage as n}from"@sentry/react";var s=(r,t)=>o(r,t),p=r=>e(r),c=r=>n(r),i=()=>({reportError:s,reportMessage:c,reportEvent:p});export{i as useSentry};
//# sourceMappingURL=index.js.map
